import { array, func, number } from 'prop-types'
import { useState } from 'react'
import {
  Button,
  kuiperClassNames,
  Conditional,
  InputV2,
} from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'
import '../styles.scss'

export const SaveContentTypeInput = ({
  contentTypeNames = [],
  maxLength,
  onCancel,
  onSubmit,
}) => {
  const [value, setValue] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [isUniqueName, setUniqueName] = useState(true)

  const shouldDisableSubmitButton = () =>
    value.length === 0 || value.length > maxLength || !isUniqueName

  const onInputSubmit = () => {
    if (shouldDisableSubmitButton()) return
    setLoading(true)
    onSubmit(value)
  }

  const setValidValue = (val) => {
    setUniqueName(!contentTypeNames.includes(val.trim()))
    setValue(val)
  }

  const handleKeyDown = (code) => {
    if (code === 13) return onInputSubmit()
    return onCancel()
  }

  return (
    <AnalyticsLayer name="Save as Content Type Popover">
      <p className={kuiperClassNames('inputText')}>Content Type Name</p>
      <Conditional condition={!isUniqueName}>
        <p className={kuiperClassNames('inputText error')}>
          Content Type name must be unique.
        </p>
      </Conditional>
      <InputV2
        aside={true}
        className={kuiperClassNames('popover-input')}
        focusOnMount={true}
        maxLength={maxLength}
        onChange={(val) => setValidValue(val)}
        theme="light"
        triggerOnKeyPress={{
          keyCodes: [13, 27],
          triggerFunction: (code) => handleKeyDown(code),
        }}
        value={value}
      />
      <div className={kuiperClassNames('buttons')}>
        <Button
          className={kuiperClassNames('cancel-button')}
          color="white"
          label="Cancel"
          onClick={onCancel}
        />
        <Button
          className={kuiperClassNames('save-button')}
          disabled={shouldDisableSubmitButton()}
          label="Save"
          isLoading={isLoading}
          theme="blue"
          onClick={onInputSubmit}
        />
      </div>
    </AnalyticsLayer>
  )
}

SaveContentTypeInput.propTypes = {
  contentTypeNames: array,
  maxLength: number,
  onCancel: func,
  onSubmit: func,
}
